import styled from "styled-components";
import { naira } from "../../../utils/data";
import { ICON_EXPIRE, ICON_LQS, ICON_NOSER, ICON_PRODUCT, ICON_PROFIT } from "../../../utils/icons";
import { useInventoryContext } from "../../../context/inventory_context";
import { useEffect } from "react";
import MiniLoader from "../../../utils/MIniLoader";
import { th } from "../../../utils/helpers";
import { StyledIcon } from "../../../styles";


const OverallInventory = () => {

      const {
            invtDataLoading, allInvtData, getInvtData,
      } = useInventoryContext();

      useEffect(() => {
            getInvtData();
      }, []);

      const {
            expProduct, lowStock, noOfCategory, topSell, totalProduct, totalService
      } = allInvtData;

      const overallInvt = [
            { title: 'Categories', icon: '', qty: noOfCategory, color: '#001E88', duration: 'Last 7 days', border: 'border-end' },
            { title: 'Total Services', icon: ICON_NOSER, qty: totalService, amount: '0', color: '#FA14FA', duration: 'Last 7 days', type: 'Revenue', border: 'border-end' },
            { title: 'Total Products', icon: ICON_PRODUCT, qty: totalProduct, amount: '0', color: '#FF1D44', duration: 'Last 7 days', type: 'Revenue', border: 'border-end' },
            { title: 'Top Selling', icon: ICON_PROFIT, qty: topSell, amount: '0', color: '#845EBC', duration: 'Last 7 days', type: 'Cost', border: 'border-end' },
            { title: 'Low Stocks', icon: ICON_LQS, qty: lowStock, amount: '0', color: '#FFA500', duration: 'Ordered', type: 'Not in stock', border: 'border-end' },
            { title: 'Expiring Products', icon: ICON_EXPIRE, qty: expProduct, amount: '0', color: '#F36960', duration: 'Total', type: 'Cost', border: 'border-end' },
      ];

      return (
            <StyledOverallInventory>

                  <div className="main-container">
                        <h4 className="grey-bold-text mb-4 d-flex align-items-center">
                              Overall Inventory
                              <MiniLoader
                                    load={invtDataLoading}
                              />
                        </h4>

                        <div className="row justify-content-center">
                              {overallInvt.map(({ title, icon, qty, amount, color, border, duration, type }, i) =>
                                    <div className="col-lg-3 col-md-6 mb-4" key={i}>
                                          <div className="d-flex justify-content-between">
                                                <div className="col">
                                                      <h6
                                                            className="fw-bold"
                                                            style={{ color, fontWeght: '600' }}
                                                      >
                                                            {title}
                                                      </h6>
                                                      <p className="grey-text fw-bold">
                                                            {th(qty || 0)}
                                                      </p>
                                                      <p className="small grey-light-text">
                                                            {duration}
                                                      </p>
                                                </div>
                                                {amount &&
                                                      <div className="col text-end">
                                                            <StyledIcon
                                                                  right
                                                                  smallText
                                                                  color={color}
                                                                  className="h5"
                                                            >
                                                                  {icon}
                                                            </StyledIcon>
                                                            <p className="grey-text">
                                                                  {naira}{amount}
                                                            </p>
                                                            <p className="small grey-light-text">
                                                                  {type}
                                                            </p>
                                                      </div>
                                                }
                                          </div>
                                    </div>
                              )}
                        </div>

                  </div>

            </StyledOverallInventory>
      );
};

export default OverallInventory;

const StyledOverallInventory = styled.div`
      


`;